import React from 'react';
import { X } from 'lucide-react';

export default function TapToPlaceOverlay({ onCancel }) {
  return (
    <div className="absolute top-0 left-0 right-0 z-20 flex items-start justify-between p-3 pointer-events-none">
      <div className="pointer-events-auto bg-garden-ink text-white text-sm font-medium px-4 py-2 rounded-full shadow-lg">
        Tap where the plant lives
      </div>
      <button
        onClick={onCancel}
        className="pointer-events-auto min-h-11 min-w-11 rounded-full bg-white text-garden-ink flex items-center justify-center shadow-lg"
        aria-label="Cancel placement"
      >
        <X size={20} />
      </button>
    </div>
  );
}
